import cn from 'classnames';
import React, { useState } from 'react';
import './IconPicker.css';
import { MaterialIcon } from './IconRegistry';
import icons from './Icons';

export interface IconPickerListProps {
  selectedIconName?: string;
  onIconSelected: (iconName: string) => void;
}

export const IconPickerList: React.FC<IconPickerListProps> = (props) => {
  const [selectedIconName, setSelectedIconName] = useState<string>(props.selectedIconName ?? '');

  const handleIconClick = (iconName: string) => {
    setSelectedIconName(iconName);
    props.onIconSelected(iconName);
  };

  return (
    <div className="iconPickerList" data-testid="iconPickerList">
      {icons.map((icon, index) => (
        <div
          key={icon.name}
          className={cn('iconWrapper', {
            selected: selectedIconName === icon.name,
          })}
          data-testid="iconWrapper"
          onClick={handleIconClick.bind(this, icon.name)}
        >
          <MaterialIcon key={index} name={icon.name} />
        </div>
      ))}
    </div>
  );
};
